import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Error from "../../components/Navbar/ui/Error";
import Loading from "../../components/Navbar/ui/Loading";
import { useGetTasksQuery } from "../../features/tasks/tasksApi";
import TaskList from "./TaskList";

const TaskContent = () => {
  const { selectedProjectId } = useSelector((state) => state.project);
  const { data: tasks, isLoading, isError, error } = useGetTasksQuery() || {};
  const [taskValues, setTaskValues] = useState([]);
  const { search } = useSelector((state) => state.search);

  useEffect(() => {
    if (tasks !== undefined) {
      let filteredTasks = tasks.filter(
        (task) => !selectedProjectId.includes(task.project.id)
      );
      if (search !== "") {
        filteredTasks = _.filter(filteredTasks, function (x) {
          return _.includes(x.taskName.toLowerCase(), search.toLowerCase());
        });
      }
      console.log("filteredTasks::", filteredTasks);
      setTaskValues(filteredTasks);
    }
  }, [selectedProjectId, tasks, search]);

  // Decided what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error header="Error !!" message={error?.message} />;
  } else if (!isLoading && !isError && tasks?.length === 0) {
    content = <Error header="Warning" message="No Task Found" />;
  } else if (!isLoading && !isError && tasks?.length > 0) {
    content =
      taskValues?.length > 0 ? (
        taskValues.map((task) => <TaskList key={task?.id} task={task} />)
      ) : (
        <Error header="Not Found!!" message={"Selected Project Task"} />
      );
  }
  return <div className="lws-task-list">{content}</div>;
};

export default TaskContent;
